/* ============================================
   Cura — Trust Strip
   Drag-to-scroll with the mouse on desktop.
   Mobile uses native touch scrolling (no JS).
   Editor-safe re-init on shopify:section:load.
   ============================================ */

(function () {
  'use strict';

  function initTrustStrip(root) {
    if (!root || root.dataset.ctsInit === 'true') return;
    root.dataset.ctsInit = 'true';

    var track = root.querySelector('[data-cts-track]');
    if (!track) return;

    var isDown = false;
    var moved = false;
    var startX = 0;
    var startScroll = 0;

    track.addEventListener('pointerdown', function (e) {
      /* mouse drag only — touch uses native momentum scrolling */
      if (e.pointerType !== 'mouse') return;
      isDown = true;
      moved = false;
      startX = e.clientX;
      startScroll = track.scrollLeft;
      track.classList.add('is-dragging');
    });

    track.addEventListener('pointermove', function (e) {
      if (!isDown) return;
      var dx = e.clientX - startX;
      if (Math.abs(dx) > 4) moved = true;
      track.scrollLeft = startScroll - dx;
    });

    function release() {
      if (!isDown) return;
      isDown = false;
      track.classList.remove('is-dragging');
    }

    track.addEventListener('pointerup', release);
    track.addEventListener('pointerleave', release);
    track.addEventListener('pointercancel', release);

    /* prevent accidental link clicks after a drag (future-proofing) */
    track.addEventListener('click', function (e) {
      if (moved) {
        e.preventDefault();
        e.stopPropagation();
        moved = false;
      }
    }, true);
  }

  function initAll() {
    document.querySelectorAll('[data-cura-trust-strip]').forEach(initTrustStrip);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('[data-cura-trust-strip]');
    if (root) {
      root.dataset.ctsInit = 'false';
      initTrustStrip(root);
    }
  });
})();